import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { pageStyles } from "./pageStyles";
import NavBar from "./NavBar";

export default function ResetPasswordPage() {
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 1500);
    } catch (err) {
      setError(err.message || "Could not reset password.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={pageStyles.page}>
      <NavBar />
      <div style={pageStyles.authWrap}>
        <form style={pageStyles.card} onSubmit={handleSubmit}>
          <h1 style={pageStyles.title}>Choose a new password</h1>
          {!token ? (
            <p style={pageStyles.subtitle}>
              This link is missing its reset token —{" "}
              <Link to="/forgot-password" style={pageStyles.link}>request a new one</Link>.
            </p>
          ) : (
            <p style={pageStyles.subtitle}>Pick something you haven't used before.</p>
          )}

          <label style={pageStyles.label} htmlFor="reset-password">New password</label>
          <input
            id="reset-password"
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={pageStyles.input}
            disabled={!token}
          />

          {error ? <div style={pageStyles.errorBanner}>{error}</div> : null}
          {done ? (
            <div style={pageStyles.successBanner}>Password updated — redirecting to sign in…</div>
          ) : null}

          <button
            type="submit"
            disabled={submitting || !token}
            style={{
              ...pageStyles.button,
              ...(submitting || !token ? pageStyles.buttonDisabled : {}),
            }}
          >
            {submitting ? "Saving…" : "Save new password"}
          </button>
        </form>
      </div>
    </div>
  );
}
